import { useEffect, useRef, useCallback } from 'react';
interface SetTimeout {
  (handler: TimerHandler, timeout?: number, ...args: any[]): number;
}
const useSetTimeout = function () {
  const didUnmountRef = useRef<boolean>();
  useEffect(() => {
    didUnmountRef.current = false;
    return () => {
      didUnmountRef.current = true;
    };
  }, []);
  const setTimeout: SetTimeout = useCallback(function (handler: TimerHandler, timeout?: number, ...args: any[]): number {
    if (typeof handler === 'string') {
      throw new Error('Não usar string em setTimeout!!!!');
    }
    return window.setTimeout((...p) => {
      if (!didUnmountRef.current) {
        handler(...p);
      }
    }, timeout, ...args);
  }, []);
  return setTimeout;
};
export default useSetTimeout;